import classNames from 'classnames';

const PromoTag = ({ className = '' }) => (
  <svg
    className={classNames('icon', className)}
    id="PromoTag"
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 1.5H9.93934C10.3372 1.5 10.7187 1.65804 11 1.93934L17.2244 8.16375C18.0968 9.04133 18.0968 10.4587 17.2228 11.3378L11.8456 16.715C11.4236 17.1375 10.8509 17.3749 10.2537 17.3749C9.65658 17.3749 9.0839 17.1375 8.66248 16.7156L2.43996 10.5004C2.15828 10.219 2 9.83721 2 9.43908V3C2 2.17157 2.67157 1.5 3.5 1.5ZM9.93934 3H3.5V9.43908L9.72312 15.655C9.8638 15.7958 10.0547 15.8749 10.2537 15.8749C10.4528 15.8749 10.6437 15.7958 10.7847 15.6547L16.1606 10.2787C16.4514 9.98622 16.4514 9.51378 16.1622 9.22283L9.93934 3ZM6.125 4.5C5.50368 4.5 5 5.00368 5 5.625C5 6.24632 5.50368 6.75 6.125 6.75C6.74632 6.75 7.25 6.24632 7.25 5.625C7.25 5.00368 6.74632 4.5 6.125 4.5Z"
    />
  </svg>
);

PromoTag.propTypes = {
  className: PropTypes.string,
};

export default PromoTag;
